import React, { useState } from "react";
import { Grid, Grow, Stack } from "@mui/material";
import RoleSelect from "../../../../components/selectors/RoleSelect";
import { Champion, targets, useReferentialContext } from "../../../../Context";
import FilterSet from "../../../../components/selectors/Filterset";
import { GameMetrics } from "../../../../farsight-api";
import MultipleMetricsSelect from "../../../../components/selectors/Shared/MetricsSelect";
import TableDisplayGrid, { rowStyle } from "../../../../components/datagrids/shared/TableDisplayGrid";
import OverviewDetailed from "../../../../components/selectors/OverviewDetailed";
import WindowContainer from "../../../../components/layout/WindowContainer";

export default function PlayersTierlists(props: { target: targets }) {
    const [detailed, setDetailed] = useState(false);

    const context = useReferentialContext();
    const [year, setYear] = useState(2023);
    const [league, setLeague] = useState(context.selectedLeagues[0] ? context.selectedLeagues[0] : null);
    const [champions, setChampions] = useState([] as Champion[]);
    const [split, setSplit] = useState(null as string | null);
    const [phases, setPhases] = useState([] as string[]);

    const [paramObject, setParamObject] = useState({
        ordering: "-performance",
    } as any);

    return (
        <WindowContainer direction={"column"} spacing={2}>
            <FilterSet
                paramObject={paramObject}
                setParamObject={setParamObject}
                target={targets.competitive}
                league={league}
                setLeague={setLeague}
                year={year}
                setYear={setYear}
                split={split}
                setSplit={setSplit}
                phases={phases}
                setPhases={setPhases}
                champions={champions}
                setChampions={setChampions}
            />
            {paramObject.league ? <PlayerTierlist target={targets.competitive} paramObject={paramObject} /> : <></>}
        </WindowContainer>
    );
}

export function PlayerTierlist(props: { paramObject: any; target: targets }) {
    const api = useReferentialContext().farsightApi.getSummariesApi(props.target);
    const [detailed, setDetailed] = useState(false);
    const [role, setRole] = useState<string>("MID_LANE");
    const [metrics, setMetrics] = useState<GameMetrics[]>(useReferentialContext().selectedMetrics);

    const tabs = detailed ? [role] : ["TOP_LANE", "JUNGLE", "MID_LANE", "BOT_LANE", "UTILITY"];

    return (
        <Stack direction={"column"} sx={{ height: "100%", width: "100%" }} spacing={2}>
            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 2000 }}>
                <Stack
                    direction={"row"}
                    sx={{
                        height: "50px",
                        justifyContent: "left",
                        width: "100%",
                    }}
                    spacing={2}
                >
                    <OverviewDetailed value={detailed} onChange={setDetailed} />
                    <Grow in={detailed} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 2000 }}>
                        <Stack
                            direction={"row"}
                            sx={{
                                height: "50px",
                                justifyContent: "left",
                                width: "100%",
                                mb: 5,
                            }}
                            spacing={2}
                        >
                            <MultipleMetricsSelect values={metrics} updateValue={setMetrics} target={props.target} updateContext={false} />
                            <RoleSelect value={role} onChange={setRole} label={`Role`} />
                        </Stack>
                    </Grow>
                </Stack>
            </Grow>
            <Stack direction={"row"} sx={{ height: "100%", width: "100%" }} spacing={1}>
                {["TOP_LANE", "JUNGLE", "MID_LANE", "BOT_LANE", "UTILITY"].map((tab_role) => {
                    const request_parameters = {
                        ...props.paramObject,
                        groupby: "player,team1",
                        metrics: detailed ? metrics.map((metric) => metric.code).toString() : ["performance", "relative_performance", "games", "winrate"].toString(),
                        ordering: "performance",
                        format: "json",
                        role: tab_role,
                    };
                    request_parameters.watermark = JSON.stringify(request_parameters);
                    return (detailed && tabs.includes(tab_role)) || !detailed ? (
                        <TableDisplayGrid
                            display_all={false}
                            request={() => api.aggregate(request_parameters)}
                            rowStyle={rowStyle.none}
                            disp_columns={detailed ? ["player", "team1"] : ["player", "team1", "games", "winrate", "performance", "relative_performance"]}
                            sortBy={"performance"}
                            paramObject={request_parameters}
                            metrics={detailed ? metrics : []}
                        />
                    ) : (
                        <></>
                    );
                })}
            </Stack>
        </Stack>
    );
}
